import { Component } from '@angular/core';

@Component({
  selector: 'app-bhoruka-fabcons-pvt-ltd',
  templateUrl: './bhoruka-fabcons-pvt-ltd.component.html',
  styleUrls: ['./bhoruka-fabcons-pvt-ltd.component.scss']
})
export class BhorukaFabconsPvtLtdComponent {

}
